/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How do I convert ${i?.category} units?`)
};

const es_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cómo convierto unidades de ${i?.category}?`)
};

const de_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wie rechne ich ${i?.category}-Einheiten um?`)
};

const nl_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoe converteer ik ${i?.category} eenheden?`)
};

const fr_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comment convertir les unités ${i?.category} ?`)
};

const it_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Come converto le unità di ${i?.category}?`)
};

const pt_br2_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Como faço para converter unidades de ${i?.category}?`)
};

const pt_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Como faço conversão de unidades de ${i?.category}?`)
};

const ja_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category}単位をどのように変換しますか?`)
};

const zh_uc_cat_faq1_q = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ category: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_faq1_q = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_faq1_q", locale)
	if (locale === "en") return en_uc_cat_faq1_q(inputs)
	if (locale === "es") return es_uc_cat_faq1_q(inputs)
	if (locale === "de") return de_uc_cat_faq1_q(inputs)
	if (locale === "nl") return nl_uc_cat_faq1_q(inputs)
	if (locale === "fr") return fr_uc_cat_faq1_q(inputs)
	if (locale === "it") return it_uc_cat_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_faq1_q(inputs)
	if (locale === "pt") return pt_uc_cat_faq1_q(inputs)
	if (locale === "ja") return ja_uc_cat_faq1_q(inputs)
	return zh_uc_cat_faq1_q(inputs)
};